// keyFactories/ux/templateKeyFactory.ts
import { ActionType, EntityType, ModuleType } from "../../queryKeyFactory";

export const templateKeyFactory = {
  // Filtered templates (main list with filters)
  templatesFilter: (
    filters?: any
  ): [ModuleType, EntityType, ActionType, any?] => [
    "ux",
    "uxTemplate",
    "filtered",
    filters,
  ],

  // Basic templates list
  templates: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxTemplate",
    "list",
  ],

  // Template by ID
  templateById: (
    templateId?: number
  ): [ModuleType, EntityType, ActionType, number?] => [
    "ux",
    "uxTemplate",
    "detail",
    templateId,
  ],

  // Message templates for specific channel
  messageTemplates: (
    channelType?: string
  ): [ModuleType, EntityType, ActionType, string?] => [
    "ux",
    "uxMessageTemplate",
    "list",
    channelType,
  ],

  // Template usage/statistics
  templateUse: (
    utilityId?: string,
    channelType?: string
  ): [ModuleType, EntityType, ActionType, string?, string?] => [
    "ux",
    "uxTemplateUse",
    "list",
    utilityId,
    channelType,
  ],

  // Placeholder related
  placeHolderGroups: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxPlaceholderGroups",
    "list",
  ],

  placeHolders: (
    category?: string
  ): [ModuleType, EntityType, ActionType, string?] => [
    "ux",
    "uxPlaceholders",
    "list",
    category,
  ],

  // Template categories/configuration
  categoryConfig: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxTemplateCategory",
    "list",
  ],

  // Templates by status
  templatesDraft: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxTemplate",
    "draft",
  ],

  templatesPublished: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxTemplate",
    "published",
  ],

  // Legacy compatibility (for old filter structure)
  templatesLegacyFilter: (
    channelType?: string,
    categoryFilter?: string,
    isDraft?: boolean,
    tagFilter?: string,
    searchData?: string
  ): [
    ModuleType,
    EntityType,
    ActionType,
    string?,
    string?,
    boolean?,
    string?,
    string?
  ] => [
    "ux",
    "uxTemplate",
    "legacyFilter",
    channelType,
    categoryFilter,
    isDraft,
    tagFilter,
    searchData,
  ],
} as const;
